import Lottie from 'lottie-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { FormattedSlot } from '@/apiTypes.ts'
import successCheckmark from '@/assets/lottie/success-checkmark.json'
import { StyledActionButton } from '@/components/Buttons.tsx'
import { Confirm } from '@/components/templates/Confirm.tsx'
import {
  ButtonGroup,
  FullScreenContainer,
} from '@/components/templates/ScreenLayout.tsx'
import { Header2 } from '@/components/Text.tsx'

const SuccessHeader = styled(Header2)`
  margin: 20px 0 40px;
`

const SuccessAnimationWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ButtonWrapper = styled(ButtonGroup)`
  position: absolute;
  bottom: 32px;
  width: calc(100% - 40px);
`

const SuccessAnimation = () => {
  return (
    <SuccessAnimationWrapper>
      <Lottie
        animationData={successCheckmark}
        autoPlay
        loop={false}
        style={{ width: 70 }}
      />
    </SuccessAnimationWrapper>
  )
}

export const Success = ({
  onClose,
  slot,
}: {
  slot: FormattedSlot
  onClose: () => void
}) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'successScreen',
  })

  return (
    <FullScreenContainer align="center">
      <SuccessAnimation />
      <SuccessHeader>{t('header')}</SuccessHeader>

      <Confirm slot={slot} />

      <ButtonWrapper>
        <StyledActionButton
          variant="Secondary"
          id="back-to-home"
          onClick={onClose}
        >
          {t('actions.close')}
        </StyledActionButton>
      </ButtonWrapper>
    </FullScreenContainer>
  )
}
